/**
 * log.js
 *
 * Provides a configurable log object, with Winston compatible Node-style
 * methods.
 *
 * By default, will suppress all console output except errors when in
 * production mode.
 */

const environment = process.env.NODE_ENV;

const enable = {
  error: true,
  warn: false,
  info: false,
  http: false,
  verbose: false,
  debug: false,
  silly: false,
};
if (environment !== 'production') {
  enable.warn = true;
  enable.info = true;
  enable.http = true;
  enable.verbose = true;
  enable.debug = true;
  enable.silly = true;
}

const log = {
  /* eslint-disable no-console */
  error(...args) {
    if (enable.error) console.error(...args);
  },
  warn(...args) {
    if (enable.warn) console.warn(...args);
  },
  info(...args) {
    if (enable.info) console.info(...args);
  },
  http(...args) {
    if (enable.http) console.log(...args);
  },
  verbose(...args) {
    if (enable.verbose) console.log(...args);
  },
  debug(...args) {
    if (enable.debug) console.log(...args);
  },
  silly(...args) {
    if (enable.silly) console.log(...args);
  },
  /* eslint-enable no-console */
};

module.exports = {
  log,
};
